$(function() {
    navbar.init();
});

var navbar = {
    init: function() {
        $('#navbarSearchInput').keyup(navbar.onKeyUp);
        $('#navbarSearchInput').blur(navbar.hideResult);
        $('#navbarSearchButton').blur(navbar.hideResult);
        navbar.initHoveredMenu();
    },
    onKeyUp: function() {
        var term = $('#navbarSearchInput').val();
        if(this.prevTerm != term) {
            if(term.length>1) {
                this.prevTerm = term;
                navbar.search($('#navbarSearchForm'));
            } else {
                navbar.hideResult();
            }
        }
    },

    prevTerm: '',
    search: function(form) {
        if(navbar.hideResultTimeOut) {
            clearTimeout(navbar.hideResultTimeOut);
        }

        var $search = $(form).find('input[type="search"]');
        var term = $search.val();

        $.ajax({
            url: "/ajaxRequest/search/findByTerm",
            dataType: "json",
            data: {
                term: term,
            },
            success: function( resp ) {
                navbar.showResult(resp.data);
            }
        });

        return false;
    },

    emptyCol: null,
    showResult: function(data) {
        $('#navbarSearch').addClass('show');
        $('#navbarSearch .dropdown-menu').addClass('show');
        var $col = $('#navbarSearchResult .row .col-lg');
        if(!navbar.emptyCol) {
            navbar.emptyCol = $col.first().clone();
        }

        var cats = [];

        $.each(data, function( index, row ) {
            if(!cats[row.category]) {
                cats[row.category] = {
                    rows: [],
                    url: row.categoryFullUrl
                };
            }
            cats[row.category].rows.push('<a href="'+row.fullUrl+'">'+row.label+'</a>');
        });

        var c = 0;

        for (var property in cats) {
            //console.log(property, cats[property]);
            if(!$col[c]) {
                $col[c] = navbar.emptyCol.clone();
                $('#navbarSearchResult .row').append($col[c]);
            }

            $($col[c]).html('<h6>'+property+'</h6>');
            $($col[c]).append(cats[property].rows.join('<br>'));
            $($col[c]).append('<br><a href="'+cats[property].url+'">Összes '+property+' találat</a>');
            c++;
        }

        //console.log('showResult',$col);
    },
    hideResultTimeOut: null,
    hideResult: function() {
        navbar.hideResultTimeOut = setTimeout(function() {
            $('#navbarSearch').removeClass('show');
            $('#navbarSearch .dropdown-menu').removeClass('show');
            //$('#navbarSearchInput').val('');
            navbar.prevTerm = '';
        }, 500);
    },

    dropdown: null,
    dropdownToggle: null,
    dropdownMenu: null,
    showClass: "show",
    activeClass: "active",
    navPills: null,
    initHoveredMenu: function() {
        navbar.dropdown = $(".dropdown.hovered");
        navbar.dropdownToggle = $(".dropdown-toggle");
        navbar.dropdownMenu = $(".dropdown-menu");
        navbar.navPills = $(".nav-pills .nav-link.hovered");
        $(window).on("load resize", navbar.onLoadOrResize);
    },
    onLoadOrResize: function() {
        if (this.matchMedia("(min-width: 768px)").matches) {
            navbar.dropdown.hover(
                function() {
                    var $this = $(this);
                    $this.removeClass('closing');
                    $this.addClass(navbar.showClass);
                    $this.find(navbar.dropdownToggle).attr("aria-expanded", "true");
                    $this.find(navbar.dropdownMenu).addClass(navbar.showClass);
                },
                function() {
                    var $this = $(this);
                    $this.addClass('closing');
                    setTimeout(function() {
                        if($this.hasClass("closing")) {
                            $this.removeClass('closing');
                            $this.removeClass(navbar.showClass);
                            $this.find(navbar.dropdownToggle).attr("aria-expanded", "false");
                            $this.find(navbar.dropdownMenu).removeClass(navbar.showClass);
                        }
                    }, 100);
                }
            );

            navbar.navPills.hover(
                function() {
                    var $this = $(this);
                    if(!$this.hasClass('active')) {
                        var $active = $this.siblings('.active').first();
                        var $activeTab = $('#' + $active.attr('aria-controls'));
                        var $thisTab = $('#' + $this.attr('aria-controls'));
                        console.log('active',$active.attr('aria-controls'));
                        console.log('this',$this.attr('aria-controls'));
                        $active.removeClass('active');
                        $active.attr('aria-selected', "false");
                        $activeTab.removeClass('active');
                        $activeTab.removeClass('show');
                        $this.addClass('active');
                        $this.attr('aria-selected', "true");
                        $thisTab.addClass('active');
                        $thisTab.addClass('show');
                    }

                }
            );
        } else {
            navbar.dropdown.off("mouseenter mouseleave");
            navbar.navPills.off("mouseenter");
        }
    }
};
